__turbopack_context__.v({
  "chat": "workshop-chat-module__XCxnTG__chat",
  "composer": "workshop-chat-module__XCxnTG__composer",
  "empty": "workshop-chat-module__XCxnTG__empty",
  "error": "workshop-chat-module__XCxnTG__error",
  "message": "workshop-chat-module__XCxnTG__message",
  "messageActions": "workshop-chat-module__XCxnTG__messageActions",
  "messages": "workshop-chat-module__XCxnTG__messages",
  "meta": "workshop-chat-module__XCxnTG__meta",
  "note": "workshop-chat-module__XCxnTG__note",
  "runActions": "workshop-chat-module__XCxnTG__runActions",
  "runPicker": "workshop-chat-module__XCxnTG__runPicker",
  "stepMark": "workshop-chat-module__XCxnTG__stepMark",
  "target": "workshop-chat-module__XCxnTG__target",
  "trace": "workshop-chat-module__XCxnTG__trace",
  "traceBody": "workshop-chat-module__XCxnTG__traceBody",
  "traceNote": "workshop-chat-module__XCxnTG__traceNote",
  "traceToggle": "workshop-chat-module__XCxnTG__traceToggle",
  "unavailable": "workshop-chat-module__XCxnTG__unavailable",
  "unread": "workshop-chat-module__XCxnTG__unread",
});
